// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sF-z","hovered":"tF-z","hoverImage":"uF-z","mainImage":"vF-z","imageNoBackground":"wF-z","fullSizeImage":"xF-z"};